import React, {Component} from "react";
import {Link} from "react-router";
import ShelfNav from "../common/nav/ShelfNav";
import MarketingNav from "../common/nav/MarketingNav";
import PricePlaceholder from "../common/PricePlaceholder";
import Footer from "../../common/Footer";
import "./Product.css";
import AnchorLink from "../../common/AnchorLink";

class Product extends Component {
    render() {
        return (
            <div>
                <ShelfNav />

                <div className="stage" id="stage">

                    <div className="block block-inverse block-hero app-header"
                         style={{backgroundImage: 'url(assets/img/splash-background.jpg)'}}>

                        <MarketingNav />

                        <div className="block-xs-middle p-b-lg">
                            <div className="container">
                                <div className="row">
                                    <div className="col-sm-10 col-md-6">
                                        <h1 className="block-title m-b-sm"><strong>Build &amp; Deploy from Slack</strong>.
                                        </h1>
                                        <p className="lead m-b-md text-muted">Trigger your Jenkins and Rundeck jobs from
                                            Slack. Deploy from anywhere.</p>
                                        <Link to="/register" className="btn btn-primary btn-lg m-t-sm-c-xs m-t-sm-c-sm m-r-sm">Try it now</Link>
                                        <AnchorLink anchorName="details" className="btn btn-info btn-lg m-t-sm-c-xs m-t-sm-c-sm">Learn more</AnchorLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section id="details">
                        <div className="block block-secondary app-iphone-block">
                            <div className="container">
                                <div className="row app-align-center">

                                    <div className="col-sm-5 hidden-xs">
                                        <img alt="Product screenshot on phone" className="app-iphone"
                                             src="assets/img/slack-app-deploy-focus_iphone7spacegrey_portrait_focus_crop.jpg" style={{width: '100%'}}/>
                                    </div>

                                    <div className="col-sm-6 col-sm-offset-1">
                                        <h6 className="text-muted text-uppercase">Deployment visibility</h6>
                                        <h3 className="m-t-0"><strong>Discuss, then deploy.</strong> Right from your team
                                            chat.</h3>
                                        <p className="lead m-b-md">Teams work better when discussion, decision and
                                            deployment all happen in one place. No more jumping between systems to figure
                                            out who deployed what to where. </p>
                                        <div className="row hidden-sm">
                                            <div className="col-sm-6 m-b-md">
                                                <h5 className="m-y-0">Tools support</h5>
                                                <p>We work with the tools teams use every day to build and deploy software,
                                                    like Jenkins and Rundeck. <Link to="/docs" className="text-primary">
                                                        Learn more</Link>.</p>
                                            </div>
                                            <div className="col-sm-6">
                                                <h5 className="m-y-0">Reliability & uptime</h5>
                                                <p>We process requests across a self-healing network of reliable servers to
                                                    ensure great uptime, always. <Link to="/docs" className="text-primary">
                                                        Learn more</Link>.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="block block-inverse block-secondary app-code-block" id="features">
                            <div className="container">
                                <div className="row app-align-center">
                                    <div className="col-sm-5 col-sm-push-6">

                                        <div className="container m-t-sm code-callout">
                                            <h4 className="m-b">Simple example</h4>
                                            <pre className="app-code app-code-little" dangerouslySetInnerHTML={{
                                                __html: `
<span>1</span>  deploy-services:
<span>2</span>    jobId: my-deploy-job
<span>3</span>    template: deploy services {version} to {environment}`
                                            }}/>
                                            <blockquote className="m-t-sm">
                                                <cite>You say:</cite>
                                                <p>
                                                    “Deploy services 1.1 to production”
                                                </p>
                                            </blockquote>

                                            <h4 className="m-b m-t-lg">Example with params</h4>
                                            <pre className="app-code app-code-little" dangerouslySetInnerHTML={{
                                                __html: `
<span>1</span>  restart-services:
<span>2</span>    jobId: my-restart-job
<span>3</span>    template: restart services in {environment}
<span>4</span>
<span>5</span>    options:
<span>6</span>      myJobParam:
<span>7</span>        value: someValue`
                                            }}/>
                                            <blockquote className="m-t-sm">
                                                <cite className="m-t-sm">You say:</cite>
                                                <p>
                                                    “Restart services in staging”
                                                </p>
                                            </blockquote>
                                        </div>

                                    </div>

                                    <div className="col-sm-6 col-sm-pull-6">
                                        <h6 className="text-muted text-uppercase">Easy setup</h6>
                                        <h3 className="m-t-0">Simple configuration makes adding jobs easy for anyone.</h3>
                                        <p className="lead m-b-md text-muted">Rather than force you to learn incredibly
                                            difficult
                                            terminal commands, we allow anyone to add jobs using a simple, logical
                                            language.</p>
                                        <p className="lead m-b-md text-muted">Just specify the Jenkins or Rundeck job to
                                            trigger, and a <i>template</i>, including any build parameters. Simple!</p>
                                        <Link to="/docs" className="btn btn-default btn-lg btn-borderless">
                                            Read our docs
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="block block-secondary app-high-praise p-b-0"
                             style={{backgroundImage: 'url(assets/img/StockSnap_DWLWL9USBG.jpg)'}}>

                            <div className="container">
                                <div className="row app-align-center">
                                    <div className="col-sm-6 col-sm-push-6 bg-primary"
                                         style={{paddingTop: "10px", paddingBottom: "2px"}}>
                                        <h6 className="text-muted text-uppercase" style={{color: 'white'}}>Totally legit
                                            quote</h6>
                                        <blockquote className="m-t-sm" style={{color: 'white'}}>
                                            <p>
                                                “CloudMocks is amazing. Deployments used to take
                                                ages and distract my developers. Now they take minutes and can be triggered
                                                by everyone in my team.”
                                            </p>
                                            <cite>&mdash; Folks using CloudMocks.</cite>
                                        </blockquote>
                                    </div>
                                    <div className="col-sm-6 col-sm-pull-5"/>
                                </div>
                            </div>

                        </div>
                    </section>

                    <PricePlaceholder />

                    <Footer />
                </div>
            </div>
        );
    }
}

export default Product;



// WEBPACK FOOTER //
// ./src/modules/views/bot/Product.js